import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'

import { setErrors } from '../common/errorsSlice'
import { ImportCsvDataResponse, RequestPostImportCsvData } from '../../types/importCsv'
import { getCsvData, postCsvData, downloadCsv } from '../../apis/settingImportCsv'

import iconv = require('iconv-lite')

export interface ImportCsvState {
  csvData: ImportCsvDataResponse[]
}

const initialState: ImportCsvState = {
  csvData: [],
}

const importCsvSyncSlice = createSlice({
  name: 'importCsvSync',
  initialState,
  reducers: {
    getCsvDataSuccess: (state, action: PayloadAction<ImportCsvDataResponse[]>) => {
      state.csvData = [...action.payload]
      return state
    },
  },
})

export const {
  getCsvDataSuccess,
} = importCsvSyncSlice.actions

export const importCsvReducer = importCsvSyncSlice.reducer
// eslint-disable-next-line @typescript-eslint/no-var-requires
const FileDownload = require('js-file-download')

export const downloadCsvData = (
  code: string,
): AppThunk => async (dispatch) => {
  downloadCsv(code)
    .then((response) => {
      const { data } = response
      if (code === 'Shift-JIS') {
        const reader = new FileReader()
        reader.onload = (e) => {
          if (e.target === null || e.target.result === null) return
          const encodeData = iconv.encode(e.target.result as string, "windows-31j")
          FileDownload(new Blob([encodeData]), 'template.csv')
        }
        reader.readAsText(data)
      } else {
        FileDownload(data, 'template.csv')
      }
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchCsvData = (
  file: string,
  callback: () => void,
  errorCallback: () => void,
  validateErrorCallback: (errors: { line: number, errors: string[] }[]) => void,
): AppThunk => async (dispatch) => {
  getCsvData(file)
    .then((result) => {
      dispatch(getCsvDataSuccess(result))
      callback()
    })
    .catch((error) => {
      if (error.status === 422) {
        validateErrorCallback(error.errors)
      } else {
        dispatch(setErrors(error))
        errorCallback()
      }
    })
}

export const uploadCsvData = (
  params: RequestPostImportCsvData,
  callback: () => void,
  errorCallback: () => void,
  validateErrorCallback: (errors: { line: number, errors: string[] }[]) => void,
): AppThunk => async (dispatch) => {
  postCsvData(params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      if (error.status === 422) {
        validateErrorCallback(error.errors)
      } else {
        dispatch(setErrors(error))
        errorCallback()
      }
    })
}
